import "./ErrorMessage.css";
import ErrorIcon from "../../../assets/error.svg?react";

interface ErrorMessageProps {
    message: string;
    light?: boolean;
    w100?: boolean;
}

const ErrorMessage = (props: ErrorMessageProps) => {
    const { message, light, w100 } = props;

    return (
        <div className={`error-message-${light ? "light" : "normal"} ${w100 ? " w-100" : ""}`}>
            {light ? null : <ErrorIcon style={{ flex: "none" }} />}
            {message}
        </div>
    );
};

export default ErrorMessage;
